import { render, staticRenderFns } from "./allDetail.vue?vue&type=template&id=43363f5a&scoped=true"
import script from "./allDetail.vue?vue&type=script&lang=js"
export * from "./allDetail.vue?vue&type=script&lang=js"
import style0 from "./allDetail.vue?vue&type=style&index=0&id=43363f5a&prod&lang=stylus&scoped=true"
import style1 from "./allDetail.vue?vue&type=style&index=1&id=43363f5a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43363f5a",
  null
  
)

export default component.exports